import React, { createContext} from "react";

  const InitalRoute = React.createContext();
  export default InitalRoute;